module.exports = __webpack_public_path__ + "50e2a0dc4394e7b939cd7ae9414ad5f2.jpg";